import { privateRouteList, publicRouteList } from '../routes/data';

export function getObservabilityRoutePatterns(): string[] {
  return [...privateRouteList, ...publicRouteList].map(route => route.path).filter(Boolean);
}
